import { hasNoElements } from "./Array";
import { isEmpty } from "./Object";

export function filterRecord<T extends string | number | symbol, S>(map: Record<T, S>, whitelist: T[]): Record<T, S> {
  if (isEmpty(map)) {
    return map;
  }

  if (hasNoElements(whitelist)) {
    return {} as Record<T, S>;
  }

  const output: Record<T, S> = {} as Record<T, S>;
  for (const entry of whitelist) {
    if (map[entry] == null) {
      continue;
    }

    output[entry] = map[entry];
  }

  return output;
}

export function recordToArray<S extends string | number | symbol, T>(record: Record<S, T>): T[] {
  if (isEmpty(record)) {
    return [];
  }

  return Object.values(record);
}
